<app-dynamicnorm-table-molecule></app-dynamicnorm-table-molecule>